import { captureRemixErrorBoundaryError, withSentry } from "@sentry/remix";
import {
	Links,
	Meta,
	Outlet,
	isRouteErrorResponse,
	useRouteError,
} from "@remix-run/react";

import {
	ThemeSwitcherSafeHTML,
	ThemeSwitcherScript,
} from "@/components/theme-switcher";

import "./globals.css";
import 'mapbox-gl/dist/mapbox-gl.css'
import React from "react";

function App({ children }: { children: React.ReactNode }) {
	return (
		<ThemeSwitcherSafeHTML lang="en">
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<Meta />
				<Links />
				<ThemeSwitcherScript />
			</head>
			<body className="flex">
				{children}
			</body>
		</ThemeSwitcherSafeHTML>
	);
}

function Root() {
	return (
		<App>
			<Outlet />
		</App>
	);
}

export default withSentry(Root);

export function ErrorBoundary() {
    const error = useRouteError();
    let status = 500;
    let message = "An unexpected error occurred.";
    if (isRouteErrorResponse(error)) {
		status = error.status;
		switch (error.status) {
			case 404:
				message = "Page Not Found";
				break;
		}
	} else {
		console.error(error);
	}

    captureRemixErrorBoundaryError(error);

    return (
		<App>
			<div className="container prose py-8">
				<h1>{status}</h1>
				<p>{message}</p>
			</div>
		</App>
	);
}